import { Service } from '../store/services/types'
import { Gender } from '../store/user/types'
import { UnauthorizedResponse } from '../types/auth'
import { callApi } from '../utils/api'
import { endpoints } from './config'

type BookingConfirmationResponse = {
  type: BookingConfirmationResponseType
  message?: string
} | null

export enum BookingConfirmationResponseType {
  AlreadyBooked = 'AlreadyBooked',
  Unauthorized = 'Unauthorized',
  UserIsBlocked = 'UserIsBlocked'
}

type ConfirmBookingForNewUserProps = {
  selectedEmployeeGuid: string
  selectedDateIsoString: string
  salonGuid: string
  selectedTimeStart: string
  firstName: string
  lastName: string
  phone: string
  email: string
  gender: Gender
  birthday: string
  newsletter: boolean
  selectedServices: Service[]
}

export const confirmBookingForNewUser = async ({
  selectedEmployeeGuid,
  selectedDateIsoString,
  salonGuid,
  selectedTimeStart,
  firstName,
  lastName,
  phone,
  email,
  gender,
  birthday,
  newsletter,
  selectedServices
}: ConfirmBookingForNewUserProps): Promise<BookingConfirmationResponse> => {
  const response = await callApi({
    path: endpoints.confirmBookingForNewUser,

    body: {
      mitarbeiterGuid: selectedEmployeeGuid,
      datum: selectedDateIsoString,
      salonGuid,
      arbeitsbeginn: selectedTimeStart,
      clientIp: '',
      vorname: firstName,
      nachname: lastName,
      telefonnummer: phone,
      email,
      geschlecht: gender,
      geburtstag: birthday,
      DeviceToken: '',
      newsletter,
      services: selectedServices.map(service => ({
        id: 0,
        guid: service.guid,
        refServicesKategorieId: 0,
        sortIndex: 0,
        name: '',
        beschreibung: '',
        preis: '',
        minuten: 0
      }))
    }
  })

  if (!response.isOk && response.data === 'Oh nein! Dieser Termin ist bereits vergeben.') {
    return { type: BookingConfirmationResponseType.AlreadyBooked }
  }

  if (!response.isOk && response.data.status === 'Gesperrt') {
    return {
      type: BookingConfirmationResponseType.UserIsBlocked,
      message: response.data.message
    }
  }

  if (!response.isOk || !response.data) {
    return null
  }

  return response.data
}

type ConfirmBookingForRegisteredUserProps = {
  selectedEmployeeGuid: string
  selectedDateIsoString: string
  salonGuid: string
  selectedTimeStart: string
  userToken: string
  selectedServices: Service[]
}

export const confirmBookingForRegisteredUser = async ({
  selectedEmployeeGuid,
  selectedDateIsoString,
  salonGuid,
  selectedTimeStart,
  userToken,
  selectedServices
}: ConfirmBookingForRegisteredUserProps): Promise<BookingConfirmationResponse> => {
  const response = await callApi({
    path: endpoints.confirmBookingForRegisteredUser,

    body: {
      mitarbeiterGuid: selectedEmployeeGuid,
      datum: selectedDateIsoString,
      salonGuid,
      arbeitsbeginn: selectedTimeStart,
      clientIp: '',
      DeviceToken: '',
      vorname: '',
      nachname: '',
      telefonnummer: '',
      email: '',
      services: selectedServices.map(service => ({
        id: 0,
        guid: service.guid,
        refServicesKategorieId: 0,
        sortIndex: 0,
        name: '',
        beschreibung: '',
        preis: '',
        minuten: 0
      }))
    },
    token: userToken
  })

  if (!response.isOk && response.data === UnauthorizedResponse) {
    return { type: BookingConfirmationResponseType.Unauthorized }
  }

  if (!response.isOk && response.data === 'Oh nein! Dieser Termin ist bereits vergeben.') {
    return { type: BookingConfirmationResponseType.AlreadyBooked }
  }

  if (!response.isOk && response.data.status === 'Gesperrt') {
    return {
      type: BookingConfirmationResponseType.UserIsBlocked,
      message: response.data.message
    }
  }

  if (!response.isOk || !response.data) {
    return null
  }

  return response.data
}
